import {
  GET_ALERTES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  alertes: [],
  error: {},
};

const Alerte = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ALERTES:
          return {
            ...state,
            alertes: action.payload.data,
            isAlerteSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_ALERTES:
          return {
            ...state,
            error: action.payload.error,
            isAlerteSuccess: false
          };
        
        default:
          return { ...state };
      }

    default:
      return { ...state };
  }
};

export default Alerte;
